/* tslint:disable */
/* eslint-disable */
/**
 * Ptw100 API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { TrackItTaskResultForEvaluationDouble } from './TrackItTaskResultForEvaluationDouble';
import {
    instanceOfTrackItTaskResultForEvaluationDouble,
    TrackItTaskResultForEvaluationDoubleFromJSON,
    TrackItTaskResultForEvaluationDoubleFromJSONTyped,
    TrackItTaskResultForEvaluationDoubleToJSON,
} from './TrackItTaskResultForEvaluationDouble';
import type { TrackItTaskResultForEvaluationOption } from './TrackItTaskResultForEvaluationOption';
import {
    instanceOfTrackItTaskResultForEvaluationOption,
    TrackItTaskResultForEvaluationOptionFromJSON,
    TrackItTaskResultForEvaluationOptionFromJSONTyped,
    TrackItTaskResultForEvaluationOptionToJSON,
} from './TrackItTaskResultForEvaluationOption';

/**
 * @type TrackItTaskResultForEvaluation
 * 
 * @export
 */
export type TrackItTaskResultForEvaluation = { $type?: 'Ptw.Ptw100.AppZero.Application.Shared.TrackItImportComponent.Dto.ImportTrackItMeasurementDto+TrackItTaskResultForEvaluationDouble, Ptw.Ptw100.AppZero.Application.Shared' } & TrackItTaskResultForEvaluationDouble | { $type?: 'Ptw.Ptw100.AppZero.Application.Shared.TrackItImportComponent.Dto.ImportTrackItMeasurementDto+TrackItTaskResultForEvaluationOption, Ptw.Ptw100.AppZero.Application.Shared' } & TrackItTaskResultForEvaluationOption;


export function TrackItTaskResultForEvaluationFromJSON(json: any): TrackItTaskResultForEvaluation {
    return TrackItTaskResultForEvaluationFromJSONTyped(json, false);
}

export function TrackItTaskResultForEvaluationFromJSONTyped(json: any, ignoreDiscriminator: boolean): TrackItTaskResultForEvaluation {
    if (json == null) {
        return json;
    }
    switch (json['$type']) {
        case 'Ptw.Ptw100.AppZero.Application.Shared.TrackItImportComponent.Dto.ImportTrackItMeasurementDto+TrackItTaskResultForEvaluationDouble, Ptw.Ptw100.AppZero.Application.Shared':
            return Object.assign({}, TrackItTaskResultForEvaluationDoubleFromJSONTyped(json, true), { $type: 'Ptw.Ptw100.AppZero.Application.Shared.TrackItImportComponent.Dto.ImportTrackItMeasurementDto+TrackItTaskResultForEvaluationDouble, Ptw.Ptw100.AppZero.Application.Shared' } as const);
        case 'Ptw.Ptw100.AppZero.Application.Shared.TrackItImportComponent.Dto.ImportTrackItMeasurementDto+TrackItTaskResultForEvaluationOption, Ptw.Ptw100.AppZero.Application.Shared':
            return Object.assign({}, TrackItTaskResultForEvaluationOptionFromJSONTyped(json, true), { $type: 'Ptw.Ptw100.AppZero.Application.Shared.TrackItImportComponent.Dto.ImportTrackItMeasurementDto+TrackItTaskResultForEvaluationOption, Ptw.Ptw100.AppZero.Application.Shared' } as const);
        default:
            throw new Error(`No variant of TrackItTaskResultForEvaluation exists with '$type=${json['$type']}'`);
    }
}

export function TrackItTaskResultForEvaluationToJSON(value?: TrackItTaskResultForEvaluation | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    switch (value['$type']) {
        case 'Ptw.Ptw100.AppZero.Application.Shared.TrackItImportComponent.Dto.ImportTrackItMeasurementDto+TrackItTaskResultForEvaluationDouble, Ptw.Ptw100.AppZero.Application.Shared':
            return TrackItTaskResultForEvaluationDoubleToJSON(value);
        case 'Ptw.Ptw100.AppZero.Application.Shared.TrackItImportComponent.Dto.ImportTrackItMeasurementDto+TrackItTaskResultForEvaluationOption, Ptw.Ptw100.AppZero.Application.Shared':
            return TrackItTaskResultForEvaluationOptionToJSON(value);
        default:
            throw new Error(`No variant of TrackItTaskResultForEvaluation exists with '$type=${value['$type']}'`);
    }

}

/**
 * Check if a given object implements the TrackItTaskResultForEvaluation interface.
 */
export function instanceOfTrackItTaskResultForEvaluation(value: any): value is TrackItTaskResultForEvaluation {
    if (instanceOfTrackItTaskResultForEvaluationDouble(value)) return true;
    if (instanceOfTrackItTaskResultForEvaluationOption(value)) return true;
    return false;
}

